export default __webpack_public_path__ + "media/images/censored-news-d2415b2d3660456ff1796e114654a3ce.svg";